export default {
  finishSale: { method: 'post', url: 'sale/finish/' },
  GetDelivery: { method: 'get', url: 'sale/GetDelivery/' },
  GetPayment: { method: 'get', url: 'sale/GetPayment/' },
  deleteProduct: { method: 'delete', url: 'sale/open/{id}/' },
  }